import { faContactBook, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useAccount } from "../state";
import { DropDownButton } from "./DropDownButton";
import { CSRF } from "./util";

export const AccountActions = () => {
  const user = useAccount();
  if (!user.user) {
    return (
      <div className="items-center justify-end flex shrink h-full border-gray border-l">
        <Link
          to="/login"
          className="h-full flex items-center px-5 bg-bright-yellow hover:text-dark-green hover:bg-yellow-light"
        >
          Login
        </Link>
      </div>
    );
  }
  const name = user.name();
  return (
    <DropDownButton title={name} className="pr-2" chevron={true}>
      <div className="absolute z-50 top-12 w-max right-0">
        <div className="static rounded-md bg-white divide-x divide-gray p-2">
          <div className="p-2">
            <Link to="/user" className="h-full flex items-center text-sm font-normal">
              <FontAwesomeIcon icon={faUser} fill="currentColor" aria-hidden="true" />
              <span className="pl-2">{name}</span>
            </Link>
          </div>
          {/*<div className="p-2 pt-0">*/}
          {/*  <Link to="/contact" className="h-full flex items-center text-sm font-normal">*/}
          {/*    <FontAwesomeIcon icon={faContactBook} fill="currentColor" aria-hidden="true" />*/}
          {/*    <span className="pl-2">Contacts</span>*/}
          {/*  </Link>*/}
          {/*</div>*/}
          <div className="p-2 pt-0">
            <form method="post" action="/auth/logout/">
              <CSRF />
              <button type="submit" className="h-full flex items-center text-sm font-normal">
                <FontAwesomeIcon icon={faContactBook} fill="currentColor" aria-hidden="true" />
                <span className="pl-2">Logout</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </DropDownButton>
  );
};
